import React, { useMemo } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import "../../styles/Auth/store.css";

const sanitizeValue = (val, isMulti) => {
    if (isMulti) {
        if (!Array.isArray(val)) return [];
        return val.filter(
            (v) =>
                v &&
                typeof v === "object" &&
                v.value !== undefined &&
                v.label !== undefined
        );
    } else {
        if (Array.isArray(val)) return val[0] || null;
        if (val && typeof val === "object" && val.value !== undefined) return val;
        return null;
    }
};

const ServiceSubCategorySelect = ({
    value,
    onChange,
    loadServiceSubCategories,
    isMulti = false,
    placeholder = "Select Service SubCategory",
    onAddServiceSubCategory,
    serviceCategoryId,
    isDisabled = false,
    cacheUniqs = []
}) => {
    const safeValue = useMemo(() => sanitizeValue(value, isMulti), [value, isMulti]);

    return (
        <AsyncPaginate
            isMulti={isMulti}
            value={safeValue}
            key={serviceCategoryId}
            cacheUniqs={[serviceCategoryId, ...cacheUniqs]}
            isDisabled={isDisabled}
            loadOptions={async (search, loadedOptions, additional) => {
                if (!serviceCategoryId) {
                    return { options: [], hasMore: false };
                }
                const res = await loadServiceSubCategories(search, loadedOptions, additional, serviceCategoryId);
                let options = res?.options || [];

                if (onAddServiceSubCategory && additional.page === 1) {
                    options.unshift({
                        value: "__ADD_SERVICE_SUBCATEGORY__",
                        label: "+ Add Service SubCategory",
                        style: { color: 'blue', fontWeight: 'bold' }
                    });
                }

                return {
                    ...res,
                    options
                };
            }}
            onChange={(val) => {
                const selected = sanitizeValue(val, isMulti);
                if (isMulti) {
                    if (selected?.some(v => v.value === "__ADD_SERVICE_SUBCATEGORY__")) {
                        if (onAddServiceSubCategory) onAddServiceSubCategory();
                        return;
                    }
                } else {
                    if (selected?.value === "__ADD_SERVICE_SUBCATEGORY__") {
                        if (onAddServiceSubCategory) onAddServiceSubCategory();
                        return;
                    }
                }
                onChange(selected);
            }}
            placeholder={placeholder}
            additional={{ page: 1 }}
            menuPortalTarget={document.body}
            styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 }),
                control: (base) => ({
                    ...base,
                })
            }}
        />
    );
};

export default ServiceSubCategorySelect;
